<script setup lang="ts">
const route = useRoute()
const appConfig = useAppConfig()
const { isHelpSlideoverOpen } = useDashboard()

const activePatient = useState('activePatient', () => null)

const links = [{
  id: 'patient',
  label: '患者列表',
  icon: 'i-heroicons-user-group',
  to: '/patient',
}]

const innerLinks = computed(() => {
  const list = [{
    id: 'design',
    label: '镜片设计',
    icon: 'i-heroicons-cpu-chip',
    to: '/design',
    disabled: !activePatient.value
  }, {
    id: 'param',
    label: '小艾订参',
    icon: 'i-heroicons-light-bulb',
    to: '/param',
    disabled: !activePatient.value
  }, {
    id: 'order',
    label: '下单',
    icon: 'i-heroicons-ticket',
    to: '/order',
    disabled: !activePatient.value
  }]

  if(activePatient.value) {
    list.unshift({
      id: 'patientItem',
      label: activePatient.value.patientName,
      icon: 'i-heroicons-identification',
      to: `/patient/${activePatient.value.id}`,
      disabled: false
    })
  }

  return list
})

const footerLinks = [{
  label: 'Invite people',
  icon: 'i-heroicons-plus',
  to: '/settings/members'
}, {
  label: 'Help & Support',
  icon: 'i-heroicons-question-mark-circle',
  click: () => isHelpSlideoverOpen.value = true
}]
const groups = [{
  key: 'links',
  label: 'Go to',
  commands: links.map(link => ({ ...link, shortcuts: link.tooltip?.shortcuts }))
}]
const defaultColors = ref(['green', 'teal', 'cyan', 'sky', 'blue', 'indigo', 'violet'].map(color => ({ label: color, chip: color, click: () => appConfig.ui.primary = color })))
const colors = computed(() => defaultColors.value.map(color => ({ ...color, active: appConfig.ui.primary === color.label })))
const doAuthLogout = () => {
  authLogout()
}

const myUi = {
  wrapper: 'relative !min-h-[auto] !min-w-[auto]',
  container: '!overflow-visible',
  base: 'gap-2.5 px-2.5 py-2.5 my-1',
  active: 'text-gray-900 dark:text-white before:bg-gray-100 dark:before:bg-gray-800',
  inactive: 'text-gray-100 dark:text-gray-400 hover:text-gray-100 dark:hover:text-white hover:before:bg-primary-400 dark:hover:before:bg-gray-800/50',
  icon: {
    base: 'flex-shrink-0 w-5 h-5 relative',
    active: 'text-gray-900 dark:text-white',
    inactive: 'text-gray-100 dark:text-gray-500 group-hover:text-gray-100 dark:group-hover:text-gray-200'
  },
  trailingIcon: {
    base: 'ml-auto w-5 h-5 transform transition-transform duration-200 flex-shrink-0',
    active: '',
    inactive: '-rotate-90'
  },
  avatar: {
    base: 'flex-shrink-0',
    size: '2xs'
  },
  chip: {
    base: 'flex-shrink-0 mx-2.5',
    size: 'sm'
  },
  badge: {
    base: 'flex-shrink-0 ml-auto relative rounded',
    color: 'gray',
    variant: 'solid',
    size: 'xs'
  },
  label: 'text-sm truncate relative',
  dot: {
    wrapper: 'w-px h-full mx-[9.5px] bg-gray-200 dark:bg-gray-700 relative',
    after: 'after:absolute after:z-[1] after:w-px after:h-full after:bg-gray-200 after:dark:bg-gray-700 after:transform after:translate-y-full',
    base: 'w-1 h-1 rounded-full absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2',
    active: 'bg-gray-900 dark:bg-white',
    inactive: 'bg-gray-400 dark:bg-gray-500 group-hover:bg-gray-700 dark:group-hover:bg-gray-200'
  },
  tooltip: {
    strategy: 'override',
    transition: {
      enterActiveClass: 'transition ease-out duration-200',
      enterFromClass: 'opacity-0',
      enterToClass: 'opacity-100',
      leaveActiveClass: 'transition ease-in duration-150',
      leaveFromClass: 'opacity-100',
      leaveToClass: 'opacity-0'
    }
  },
  transition: {
    enterActiveClass: 'overflow-hidden transition-[height] duration-200 ease-out',
    leaveActiveClass: 'overflow-hidden transition-[height] duration-200 ease-out'
  }
}

const myUi2 = computed(() => {
  return {
    wrapper: 'relative !min-h-[auto] !min-w-[auto]',
    container: '!overflow-visible',
    base: 'gap-2.5 px-2.5 py-2.5 my-1 ' + (activePatient.value?'':'cursor-not-allowed'),
    active: 'text-gray-900 dark:text-white before:bg-gray-100 dark:before:bg-gray-800',
    inactive: 'text-gray-100 dark:text-gray-400 hover:text-gray-100 dark:hover:text-white hover:before:bg-primary-400 dark:hover:before:bg-gray-800/50',
    icon: {
      base: 'flex-shrink-0 w-5 h-5 relative',
      active: 'text-gray-900 dark:text-white',
      inactive: 'text-gray-100 dark:text-gray-500 group-hover:text-gray-100 dark:group-hover:text-gray-200'
    },
    trailingIcon: {
      base: 'ml-auto w-5 h-5 transform transition-transform duration-200 flex-shrink-0',
      active: '',
      inactive: '-rotate-90'
    },
    avatar: {
      base: 'flex-shrink-0',
      size: '2xs'
    },
    chip: {
      base: 'flex-shrink-0 mx-2.5',
      size: 'sm'
    },
    badge: {
      base: 'flex-shrink-0 ml-auto relative rounded',
      color: 'gray',
      variant: 'solid',
      size: 'xs'
    },
    label: 'text-sm truncate relative',
    dot: {
      wrapper: 'w-px h-full mx-[9.5px] bg-gray-200 dark:bg-gray-700 relative',
      after: 'after:absolute after:z-[1] after:w-px after:h-full after:bg-gray-200 after:dark:bg-gray-700 after:transform after:translate-y-full',
      base: 'w-1 h-1 rounded-full absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2',
      active: 'bg-gray-900 dark:bg-white',
      inactive: 'bg-gray-400 dark:bg-gray-500 group-hover:bg-gray-700 dark:group-hover:bg-gray-200'
    },
    tooltip: {
      strategy: 'override',
      transition: {
        enterActiveClass: 'transition ease-out duration-200',
        enterFromClass: 'opacity-0',
        enterToClass: 'opacity-100',
        leaveActiveClass: 'transition ease-in duration-150',
        leaveFromClass: 'opacity-100',
        leaveToClass: 'opacity-0'
      }
    },
    transition: {
      enterActiveClass: 'overflow-hidden transition-[height] duration-200 ease-out',
      leaveActiveClass: 'overflow-hidden transition-[height] duration-200 ease-out'
    }
  }
})

</script>
<template>
  <UDashboardLayout>
    <UDashboardPanel :width="250" :resizable="{ min: 200, max: 300 }"  collapsible class="bg-primary">
      <UDashboardNavbar class="!border-transparent" :ui="{ left: 'flex-1' }">
        <template #left>
          <div class="flex-1 flex-shrink-0 w-full p-2 bg-white/90 rounded-md">
            <img src="../public/图片1.png" alt="" class="w-full max-w-64 h-full object-contain">
          </div>
        </template>
      </UDashboardNavbar>

      <UDashboardSidebar>

        <UDashboardSidebarLinks
            :links="links"
            :ui="myUi"
            class="select-none"
            style="color: black"
        >

        </UDashboardSidebarLinks>

        <UDivider />

        <UDashboardSidebarLinks
            :links="innerLinks"
            :ui="myUi2"
            class="select-none"
        >

        </UDashboardSidebarLinks>


        <UDashboardSidebarLinks v-if="false" :links="[{ label: 'Colors', draggable: true, children: colors }]" @update:links="colors => defaultColors = colors" />

        <div class="flex-1" />

        <UDashboardSidebarLinks v-if="false" :links="footerLinks" />

        <!--        <UDivider class="sticky bottom-0" />-->

        <template #footer>
          <!-- ~/components/UserDropdown.vue -->
          <UserDropdown />
        </template>
      </UDashboardSidebar>
    </UDashboardPanel>

    <nuxt-page />

    <!-- ~/components/HelpSlideover.vue -->
    <HelpSlideover />
    <!-- ~/components/NotificationsSlideover.vue -->
    <NotificationsSlideover />

    <ClientOnly>
      <LazyUDashboardSearch :groups="groups" />
    </ClientOnly>
  </UDashboardLayout>
</template>

<style scoped>

</style>
